import { NEXT_PAGE_IN_FLOW, PAGE_ID_BY_KEY } from "./constants";

// Map selected page KEYS to IDs
export function getSelectedPageIds(selectedPageCheckbox) {
  var result = [];
  if (!Array.isArray(selectedPageCheckbox)) return result;
  for (let key of selectedPageCheckbox) {
    result.push(PAGE_ID_BY_KEY[key]);
  }

  return result;
}

export function computeNextPageId(currentPageId, selectedPageIds) {
  if (!NEXT_PAGE_IN_FLOW[currentPageId]) return "606251184f1a60001239c7ce"; // BASE CASE: Submission Page
  if (selectedPageIds.includes(NEXT_PAGE_IN_FLOW[currentPageId]))
    return NEXT_PAGE_IN_FLOW[currentPageId];
  // Recurse over the list until a match is found or base case is reached
  return computeNextPageId(NEXT_PAGE_IN_FLOW[currentPageId], selectedPageIds);
}
